import React from 'react';
import { CHART_NAME_MAX_LENGTH } from '../../../../config/constants';
import { DescriptionField, NameField } from '../../../Form';

interface IProps {
  analysisName: string;
  setAnalysisName: (newValue: string) => void;
  analysisDescription: string;
  setAnalysisDescription: (newValue: string) => void;
  disabled?: boolean;
}

export default ({
  analysisName,
  setAnalysisName,
  analysisDescription,
  setAnalysisDescription,
  disabled,
}: IProps) => (
  <>
    <NameField
      label={'Chart name'}
      value={analysisName}
      targetErrorElement="Chart"
      maxLength={CHART_NAME_MAX_LENGTH}
      onChange={setAnalysisName}
      disabled={disabled}
    />
    <DescriptionField
      label={'Chart description'}
      value={analysisDescription}
      targetErrorElement="Chart"
      onChange={setAnalysisDescription}
      disabled={disabled}
    />
  </>
);
